'use client';

import { useTranslations } from 'next-intl';
import type { PostCardFields } from '../_server/types';
import { FeaturedPost } from './featured-post';
import { PostCard } from './post-card';

export function GazetteFrontPage({
  featuredPost,
  posts,
}: {
  featuredPost: PostCardFields;
  posts: PostCardFields[];
}) {
  const t = useTranslations('Blog.Post.More');
  const supportingPosts = posts
    .filter((post) => post.id !== featuredPost.id)
    .slice(0, 3);

  return (
    <div
      className="gazette-front-page-region"
      style={{ display: 'var(--featured-card-display, block)' }}
    >
      <div className="gazette-front-page">
        <FeaturedPost post={featuredPost} />
        {supportingPosts.length > 0 && (
          <aside className="gazette-briefs" aria-label={t('MoreFrom')}>
            <h2 className="gazette-briefs-title">{t('MoreFrom')}</h2>
            <ul className="gazette-briefs-list">
              {supportingPosts.map((post) => (
                <li key={post.id}>
                  <PostCard post={post} />
                </li>
              ))}
            </ul>
          </aside>
        )}
      </div>
    </div>
  );
}
